import React from 'react';
import classNames from 'classnames';

const Select = ({ label = '', labelClass = 'text-md--light', options = [], placeholder = '', error = '', keyId = 'id', keyLabel = 'label', showSpanError = true, isCapitalize = false, ...props, }) => (
    <div>
        <div className={classNames('ui-input-group', { error: (error !== '') })}>
            <label htmlFor={props.id} className={labelClass}>{label}</label>
            <div className="bg-white">
                <select {...props} className={(isCapitalize) ? 'ui-form-control text-capitalize' : 'ui-form-control'} >
                    { placeholder && <option value="" disabled>{placeholder}</option>}
                    {options.map((opt, index) => <option className={(isCapitalize) ? 'text-capitalize' : ''} key={`${props.id}-${index}`} value={opt[keyId]}>{opt[keyLabel]}</option>)}
                </select>
                <span className="ui-input-group-addon-right">
                    <span className="icon-nav-down" />
                </span>
            </div>
        </div>
        { showSpanError && <div className="text-error text-left">{error}</div>}
    </div>
);


export default Select;



// WEBPACK FOOTER //
// ./src/components/shared/form/select.jsx